import {Modal} from 'react-bootstrap'
import {
  cancelDeleteEmployee,
  confirmDeleteEmployee
} from 'actions/employees/list'
import styles from './ConfirmDeleteModal.css'

class ConfirmDeleteModal extends React.Component {
  render () {
    let {showDeleteEmployeeModal, deletedEmployee} = this.props

    if (!deletedEmployee) return <div />

    return (<Modal show={showDeleteEmployeeModal} onHide={this._onHide} bsClass='employee-list-delete-modal margin-top-modal modal'>
      <Modal.Header bsClass={`modal-header ${styles.header}`}>
        Delete Employee
      </Modal.Header>
      <Modal.Body>
        {this._isJSONFromEmployee(deletedEmployee) && `Are you sure want to remove ${deletedEmployee.user.first_name} ${deletedEmployee.user.last_name} ?`}
        {!this._isJSONFromEmployee(deletedEmployee) && `Are you sure want to remove ${deletedEmployee.first_name} ${deletedEmployee.last_name} ?`}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={this._onHide} className='btn btn-default'>Cancel</button>
        <button onClick={this._onConfirm} className='btn btn-danger'>Delete</button>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(cancelDeleteEmployee())
  }

  _onConfirm = () => {
    let {deletedEmployee, dispatch} = this.props
    dispatch(confirmDeleteEmployee(deletedEmployee))
  }

  _isJSONFromEmployee = (json) => {
    return json.hasOwnProperty('user')
  }
}

ConfirmDeleteModal.propTypes = {
  showDeleteEmployeeModal: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  deletedEmployee: React.PropTypes.object
}

export default ConfirmDeleteModal



// WEBPACK FOOTER //
// ./app/pages/Employees/List/ConfirmDeleteModal/ConfirmDeleteModal.js